export enum OrderStatus {
  PAID = 'PAID',
  PARTIALLY = 'PARTIALLY',
  FULLY_RECEIVED = 'FULLY_RECEIVED',
  PENDING = 'PENDING',
  PASS_DUE = 'PASS_DUE',
  CANCEL = 'CANCEL',
  FAIL = 'FAIL',
}

export const pendingOrderStatus = [
  OrderStatus.PENDING,
  OrderStatus.PARTIALLY,
  OrderStatus.FULLY_RECEIVED,
];
